import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import client from '@/api/client';
import { parseEnvelope } from '@/api/envelope';
import { accountSchema, canonicalAccountSchema, type Account } from '@/api/hooks/useAccounts';

const updateResponseSchema = z.union([canonicalAccountSchema, accountSchema]);

export interface UpdateManualAccountInput {
  accountId: string;
  display_name?: string;
  business_use?: Account['business_use'];
}

export function useUpdateManualAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateManualAccountInput) => {
      const body: Pick<UpdateManualAccountInput, 'display_name' | 'business_use'> = {
        ...(input.display_name !== undefined ? { display_name: input.display_name } : {}),
        ...(input.business_use !== undefined ? { business_use: input.business_use } : {}),
      };
      const response = await client.patch(`/api/accounts/${input.accountId}`, body);
      return parseEnvelope(updateResponseSchema, response.data).data;
    },
    onSuccess: (_account, input) => {
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
      queryClient.invalidateQueries({ queryKey: ['accounts', 'primary-detail', input.accountId] });
    },
  });
}
